var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPicView || _vm.isProjectRepresentative
    ? _c(
        "div",
        {
          staticClass: "project-documents-add-doc-type float-right",
          attrs: { id: "project-documents-add-doc-type" },
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: {
                id: "project-documents-documents-add",
                type: "button",
                disabled: _vm.isProjectCompleted,
              },
              on: { click: _vm.openModal },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("project.docs.addFolder")) + "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Modal",
            {
              ref: "docTypeModal",
              attrs: {
                className: "add-doc-type-modal",
                modalId: "addDocTypeModal_" + +new Date(),
              },
            },
            [
              _c("div", { attrs: { id: "confirm-create-container" } }, [
                _c("p", { staticClass: "confirm-header" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("project.docs.addFolders")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { attrs: { colspan: "2" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("project.docs.projectFolder")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.docTypes, function (doctype, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(doctype.folderType))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "float-right" }, [
                            doctype.amount > 0
                              ? _c("i", {
                                  staticClass: "fa fa-minus cursor",
                                  attrs: { "aria-hidden": "true" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateDocTypeAmount(
                                        index,
                                        false
                                      )
                                    },
                                  },
                                })
                              : _c("i", {
                                  staticClass:
                                    "fa fa-minus cursor disabled-minus",
                                  attrs: { "aria-hidden": "true" },
                                }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: doctype.amount,
                                  expression: "doctype.amount",
                                },
                              ],
                              staticClass: "doctype-amount",
                              attrs: { type: "text", disabled: "" },
                              domProps: { value: doctype.amount },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    doctype,
                                    "amount",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-plus cursor",
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function ($event) {
                                  return _vm.updateDocTypeAmount(index, _vm.add)
                                },
                              },
                            }),
                          ]),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-right nav_btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.cancel")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { type: "button", disabled: _vm.disableBtn },
                    on: {
                      click: function ($event) {
                        return _vm.add()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("action.add")) + "\n      "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }